import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CoinIcon } from '../../../model/icons';
import TransactionLine from './TransactionLine';

// Панель «Центральный банк»: баланс, комиссия, корректировка, статистика субсидий, транзакции.
export default function CentralBankPanel({ fairState, teamName, colorOf }) {
    const [amount, setAmount] = useState('');
    const bank = fairState.game?.centralBank;
    const commission = bank?.commissionBalance ?? 0;
    const stats = fairState.subsidyStats;

    const update = () => {
        if (!amount || Number(amount) === 0) return;
        fairState.addCentralBankBalance(Number(amount));
        setAmount('');
    };

    return (
        <div className="bt-panel">
            <div className="fr-cbtop">
                <div>
                    <h2 className="fr-vtitle">Центральный банк</h2>
                    <div className="fr-sub">Управление балансом центрального банка для субсидий</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                    <div className="fr-bal lg">{fairState.centralBankBalance} <CoinIcon /></div>
                    <div className="fr-comm">Комиссия банка: {commission}</div>
                </div>
            </div>

            <div className="fr-adjbar">
                <div className="fr-adjnote">Положительные числа — пополнение, отрицательные — снятие</div>
                <div className="fr-adjctl">
                    <input className="input" type="number" placeholder="+/−" value={amount} onChange={(e) => setAmount(e.target.value)} />
                    <button type="button" className="btn btn-primary" onClick={update} disabled={!amount}>Обновить</button>
                </div>
            </div>

            {stats.count > 0 && (
                <>
                    <div className="fr-subhead">Статистика субсидий</div>
                    <div className="fr-stats">
                        <div className="fr-stat navy"><div className="k">Всего транзакций</div><div className="v">{stats.count}</div></div>
                        <div className="fr-stat clay"><div className="k">Потрачено из ЦБ</div><div className="v">{stats.totalAmount} <CoinIcon /></div></div>
                        <div className="fr-stat green"><div className="k">Средняя субсидия</div><div className="v">{stats.averageAmount} <CoinIcon /></div></div>
                    </div>
                </>
            )}

            <div className="ev-head" style={{ marginTop: 18 }}>
                <h2>Транзакции с субсидиями <span className="fr-cnt">({fairState.subsidyTransactions.length})</span></h2>
            </div>
            {fairState.subsidyTransactionsLoading ? (
                <div className="bt-empty">Загрузка…</div>
            ) : fairState.subsidyTransactions.length > 0 ? (
                <div>
                    {fairState.subsidyTransactions.map(tx => (
                        <TransactionLine key={tx.id} tx={tx} teamName={teamName} colorOf={colorOf} />
                    ))}
                </div>
            ) : <div className="bt-empty">Нет транзакций с субсидиями</div>}
        </div>
    );
}

CentralBankPanel.propTypes = {
    fairState: PropTypes.object.isRequired,
    teamName: PropTypes.func.isRequired,
    colorOf: PropTypes.func.isRequired
};
